import { type ReactElement } from 'react';
import { formatDuration } from '@/ui/formatters/formatDuration';
import { Text } from '@/ui/primitives';

export const TableV2DurationCell = ({
  value,
}: {
  value: number | null | undefined;
}): ReactElement => (
  <Text role="body" color="textSecondary">
    {value === null || value === undefined ? '-' : formatDuration(value)}
  </Text>
);
